import { render } from "./saved-item.vue?vue&type=template&id=7e4a5477&scoped=true"
import script from "./saved-item.vue?vue&type=script&lang=js"
export * from "./saved-item.vue?vue&type=script&lang=js"

import "./saved-item.vue?vue&type=style&index=0&id=7e4a5477&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4a5477"]])

export default __exports__